// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root variables for consistent theming */
:root {
  --color-primary: #6644CC;
  --color-accent-1: #FF6B6B;
  --color-accent-2: #28C76F;
  --color-text-dark: #333333;
  --color-text-light: #666666;
  --color-background-light: #F8F9FA;
  --color-card-background: #FFFFFF;
  --color-hover-light: #F0EBFF;
  --color-border: #E0E0E0;
}

/* Sidebar Styles */
.sidebar {
  width: 280px;
  transition: width 0.3s ease-in-out, transform 0.3s ease-in-out;
  flex-shrink: 0;
  position: fixed;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border-right: 1px solid var(--color-border);
}

.sidebar.collapsed {
  width: 100px;
}

/* Sidebar Menu Items */
.sidebar ul li button {
  display: flex;
  align-items: center;
  width: 100%;
  /* padding: 12px 16px; */
  /* gap: 12px; */
  overflow: hidden;
  white-space: nowrap;
  color: var(--color-text-light);
  border-radius: 12px;
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;
}

.sidebar.collapsed ul li button {
  justify-content: center;
  /* padding: 12px; */
}

.sidebar ul li button:hover {
  background-color: var(--color-hover-light);
  color: var(--color-primary);
  transform: translateX(4px);
}

.sidebar ul li button.text-primary-dark {
  background-color: var(--color-hover-light);
  color: var(--color-primary);
  font-weight: 600;
}

/* SVG Icons */
.sidebar ul li button svg {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  transition: transform 0.2s ease;
}

.sidebar ul li button:hover svg {
  transform: scale(1.1);
}

/* Sidebar Text */
.sidebar .sidebar-text {
  opacity: 1;
  max-width: 200px;
  transition: opacity 0.3s ease-in-out, max-width 0.3s ease-in-out, margin-left 0.3s ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
}

.sidebar.collapsed .sidebar-text {
  opacity: 0;
  max-width: 0;
  margin-left: -12px;
}

/* Submenu Styles */
.sidebar ul ul {
  border-left: 2px solid var(--color-border);
  margin-left: 28px;
  padding-left: 12px;
  animation: slideDown 0.3s ease-out;
}

.sidebar ul ul li button {
  padding: 8px 16px;
  font-size: 0.95rem;
}

.sidebar.collapsed ul ul {
  display: none; /* Ensure submenus are hidden when collapsed */
}

/* User Profile and Logout Section */
.sidebar .mt-auto {
  margin-top: auto;
  padding-top: 24px;
  border-top: 1px solid var(--color-border);
}

.sidebar .mt-auto .bg-accent-1 {
  background-color: var(--color-accent-1);
}

.sidebar .mt-auto .hover\\:bg-red-600:hover {
  background-color: color-mix(in srgb, var(--color-accent-1) 85%, black);
}

/* Scrollbar Styling */
.sidebar .flex-grow {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sidebar ul {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--color-primary) var(--color-background-light);
  flex-grow: 1;
  padding-bottom: 1rem;
}

.sidebar ul::-webkit-scrollbar {
  width: 6px;
}

.sidebar ul::-webkit-scrollbar-track {
  background: var(--color-background-light);
  border-radius: 10px;
}

.sidebar ul::-webkit-scrollbar-thumb {
  background-color: var(--color-primary);
  border-radius: 10px;
  border: 1px solid var(--color-background-light);
}

.sidebar ul::-webkit-scrollbar-thumb:hover {
  background-color: color-mix(in srgb, var(--color-primary) 80%, black);
}

/* Animations */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-slide-down {
  animation: slideDown 0.3s ease-out;
}

.animate-fade-in {
  animation: fadeIn 0.3s ease-out;
}

/* Mobile and Tablet Adjustments */
@media (max-width: 1023px) {
  .sidebar {
    width: 260px;
    transform: translateX(-100%);
  }
  .sidebar.open-mobile {
    transform: translateX(0);
  }
  .sidebar.open-mobile .sidebar-text {
    opacity: 1;
    max-width: 200px;
    margin-left: 0;
  }
  .sidebar:not(.open-mobile) {
    transform: translateX(-100%);
  }
  .sidebar.open-mobile.collapsed {
    width: 260px;
  }
  .sidebar.open-mobile.collapsed .sidebar-text {
    opacity: 1;
    max-width: 200px;
    margin-left: 0;
  }
  #sidebar-close-mobile {
    display: block !important;
  }
}

@media (max-width: 767px) {
  .sidebar {
    width: 240px;
  }
  .sidebar ul li button {
    padding: 10px 14px;
  }
  .sidebar ul ul li button {
    padding: 8px 14px;
  }
}

@media (min-width: 1024px) {
  #sidebar-close-mobile {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/newtest/nav/Navbar.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,8DAA8D;EAC9D,cAAc;EACd,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,gBAAgB;EAChB,8FAA8F;EAC9F,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,8CAA8C;AAC/D;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sEAAsE;AACxE;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mEAAmE;EACnE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,qEAAqE;AACvE;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;EACE;IACE,YAAY;IACZ,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Root variables for consistent theming */\n:root {\n  --color-primary: #6644CC;\n  --color-accent-1: #FF6B6B;\n  --color-accent-2: #28C76F;\n  --color-text-dark: #333333;\n  --color-text-light: #666666;\n  --color-background-light: #F8F9FA;\n  --color-card-background: #FFFFFF;\n  --color-hover-light: #F0EBFF;\n  --color-border: #E0E0E0;\n}\n\n/* Sidebar Styles */\n.sidebar {\n  width: 280px;\n  transition: width 0.3s ease-in-out, transform 0.3s ease-in-out;\n  flex-shrink: 0;\n  position: fixed;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  border-right: 1px solid var(--color-border);\n}\n\n.sidebar.collapsed {\n  width: 100px;\n}\n\n/* Sidebar Menu Items */\n.sidebar ul li button {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  /* padding: 12px 16px; */\n  /* gap: 12px; */\n  overflow: hidden;\n  white-space: nowrap;\n  color: var(--color-text-light);\n  border-radius: 12px;\n  transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;\n}\n\n.sidebar.collapsed ul li button {\n  justify-content: center;\n  /* padding: 12px; */\n}\n\n.sidebar ul li button:hover {\n  background-color: var(--color-hover-light);\n  color: var(--color-primary);\n  transform: translateX(4px);\n}\n\n.sidebar ul li button.text-primary-dark {\n  background-color: var(--color-hover-light);\n  color: var(--color-primary);\n  font-weight: 600;\n}\n\n/* SVG Icons */\n.sidebar ul li button svg {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  transition: transform 0.2s ease;\n}\n\n.sidebar ul li button:hover svg {\n  transform: scale(1.1);\n}\n\n/* Sidebar Text */\n.sidebar .sidebar-text {\n  opacity: 1;\n  max-width: 200px;\n  transition: opacity 0.3s ease-in-out, max-width 0.3s ease-in-out, margin-left 0.3s ease-in-out;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 1rem;\n  font-family: 'Poppins', sans-serif;\n}\n\n.sidebar.collapsed .sidebar-text {\n  opacity: 0;\n  max-width: 0;\n  margin-left: -12px;\n}\n\n/* Submenu Styles */\n.sidebar ul ul {\n  border-left: 2px solid var(--color-border);\n  margin-left: 28px;\n  padding-left: 12px;\n  animation: slideDown 0.3s ease-out;\n}\n\n.sidebar ul ul li button {\n  padding: 8px 16px;\n  font-size: 0.95rem;\n}\n\n.sidebar.collapsed ul ul {\n  display: none; /* Ensure submenus are hidden when collapsed */\n}\n\n/* User Profile and Logout Section */\n.sidebar .mt-auto {\n  margin-top: auto;\n  padding-top: 24px;\n  border-top: 1px solid var(--color-border);\n}\n\n.sidebar .mt-auto .bg-accent-1 {\n  background-color: var(--color-accent-1);\n}\n\n.sidebar .mt-auto .hover\\:bg-red-600:hover {\n  background-color: color-mix(in srgb, var(--color-accent-1) 85%, black);\n}\n\n/* Scrollbar Styling */\n.sidebar .flex-grow {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.sidebar ul {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--color-primary) var(--color-background-light);\n  flex-grow: 1;\n  padding-bottom: 1rem;\n}\n\n.sidebar ul::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar ul::-webkit-scrollbar-track {\n  background: var(--color-background-light);\n  border-radius: 10px;\n}\n\n.sidebar ul::-webkit-scrollbar-thumb {\n  background-color: var(--color-primary);\n  border-radius: 10px;\n  border: 1px solid var(--color-background-light);\n}\n\n.sidebar ul::-webkit-scrollbar-thumb:hover {\n  background-color: color-mix(in srgb, var(--color-primary) 80%, black);\n}\n\n/* Animations */\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.animate-slide-down {\n  animation: slideDown 0.3s ease-out;\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.3s ease-out;\n}\n\n/* Mobile and Tablet Adjustments */\n@media (max-width: 1023px) {\n  .sidebar {\n    width: 260px;\n    transform: translateX(-100%);\n  }\n  .sidebar.open-mobile {\n    transform: translateX(0);\n  }\n  .sidebar.open-mobile .sidebar-text {\n    opacity: 1;\n    max-width: 200px;\n    margin-left: 0;\n  }\n  .sidebar:not(.open-mobile) {\n    transform: translateX(-100%);\n  }\n  .sidebar.open-mobile.collapsed {\n    width: 260px;\n  }\n  .sidebar.open-mobile.collapsed .sidebar-text {\n    opacity: 1;\n    max-width: 200px;\n    margin-left: 0;\n  }\n  #sidebar-close-mobile {\n    display: block !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .sidebar {\n    width: 240px;\n  }\n  .sidebar ul li button {\n    padding: 10px 14px;\n  }\n  .sidebar ul ul li button {\n    padding: 8px 14px;\n  }\n}\n\n@media (min-width: 1024px) {\n  #sidebar-close-mobile {\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
